module.exports = __webpack_public_path__ + "img/Weapon_13.52198100.png";